//
import { get } from "lodash";
import { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { BsFillArrowLeftSquareFill, BsFillClockFill } from "react-icons/bs";
import RightArrow from "src/assets/images/transfer/right-arrow.gif";
import { FcCancel } from "react-icons/fc";
import { RiMoneyDollarCircleFill } from "react-icons/ri";
import { HiArrowRight, HiUser, HiCalendar, HiClock, HiCurrencyDollar, HiInformationCircle, HiCheckCircle, HiXCircle, HiExclamationTriangle, HiShieldExclamation } from "react-icons/hi2";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import useQueryDetailDeposit from "src/hooks/useQueryDetailDeposit";
import { DepositPics, IAccountForm, TransferOpinion } from "src/types";
import {
  dateToLocal,
  dateToLocalComplete,
  dateToLocalHour,
  getDollarOneImg,
  getFiatName,
  getHourDateExpirate,
  getProfileDefaultImage,
  money,
} from "../../../helpers/mixins";
import DepositStatus from "../../Shared/DepositStatus";
import SkeletonDepositDetail from "../../Shared/Skeletons/SkeletonDepositDetail";
import UploadManyFiles from "src/components/Shared/DepositUploadManyFiles";
import { useAppStateContext } from "src/auth/AppStateContext";

import { Popover, Tooltip } from "antd";
import DialogConfirm from "src/components/Shared/DialogInfoGeneral";
import { AiOutlineDislike, AiOutlineLike } from "react-icons/ai";
import APIService from "src/services/Api";
import { ImSpinner9 } from "react-icons/im";
import GalleryPics from "src/components/Shared/GalleryPics";
import ViewDepositStatus from "src/components/Shared/ViewDepositStatus";
import { UseAuth } from "src/auth/AuthContext";

import OpenChatTransfer from "src/components/Shared/OpenChatTransfer";
import AppealResume from "src/components/System/AppealResume";
import { IoCloseCircleSharp, IoStar } from "react-icons/io5";
import FormatLastConnection from "src/components/Shared/FormatLastConnection";

const DepositDetail: React.FC = () => {
  const { t } = useTranslation();
  const { state } = useLocation();
  const { transferId } = useParams();
  const navigate = useNavigate();
  const { user } = UseAuth();
  //@ts-ignore
  const { depositDetail, loading } = useQueryDetailDeposit(
    state?.id || transferId
  );
  const answers = [
    "información incorrecta en los detalles proporcionados",
    "dinero no recibido",
    "dinero incompleto",
  ];
  const { processors, fetchProccesors } = useAppStateContext();
  //const [usercountry, setUsercountry] = useState<string>("");
  const [loadingUploadPics, setLoadingUploadPics] = useState<boolean>(false);
  const [status, setStatus] = useState<string>();
  const [loadingCancel, setLoadingCancel] = useState(false);
  const [successCancel, setSuccessCancel] = useState<string>("");
  const [opinion, setOpinion] = useState<TransferOpinion>();
  const [commentCancel, setCommentCancel] = useState<string>();
  const [cashierReceivedMoney, setCashierReceivedMoney] = useState<string>("");
  const [methodPayment, setMethodPayment] = useState<IAccountForm>();
  const [pics, setPics] = useState<DepositPics[]>([]);

  const [showDialogRefusePayment, setShowDialogRefusePayment] =
    useState<boolean>(false);
  /*   const [showDialogIncompletePayment, setShowDialogIncompletePayment] =
    useState<boolean>(false); */
  useEffect(() => {
    setStatus(get(depositDetail, "status", ""));
    //setUsercountry(get(depositDetail, "user.country", ""));
    setMethodPayment(JSON.parse(depositDetail?.accountsendstringify || "{}"));
  }, [depositDetail]);

  useEffect(() => {
    setCashierReceivedMoney("");
  }, []);

  useEffect(() => {
    if (depositDetail && status) {
      fetchPics(depositDetail?.id?.toString() || "");
    }
  }, [depositDetail, status]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (depositDetail && status) {
        fetchPics(depositDetail?.id);
      }
    }, 60000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  const handleCommentCancel = (c: string) => {
    if (c.length > 200) {
      c = c.substring(0, 200);
    }
    setCommentCancel(c);
  };

  const handleSuccessCancel = () => {
    setShowDialogRefusePayment(false);
    setSuccessCancel("");
    setCashierReceivedMoney("refused");
  };

  const handleRefuseTransfer = async () => {
    setLoadingCancel(true);
    const data = {
      deposit: depositDetail?.id || "",
      newstatus: "refused",
      origen: "cashier",
      motive: commentCancel,
    } as any;
    /* if (newStatus === "cancel" || newStatus === "refused") {
      data.motive = motive;
    } */
    const updated = await APIService.systemDepositUpdateStatus(data);
    if (updated.data.status) {
      setCashierReceivedMoney("");
      setStatus("refused");
      setSuccessCancel("yes");
    } else {
      setSuccessCancel("no");
    }
    setLoadingCancel(false);
  };

  const [anwersConfirmRefused, setAnwersConfirmRefused] = useState(false);

  const openMotiveWindow = () => {
    setCommentCancel("");
    setShowDialogRefusePayment(true);
  };

  const fetchPics = async (depositId: string) => {
    const x = await APIService.depositListAnyPic({ depositId });
    const p = x?.data?.data as DepositPics[];
    setPics(p);
  };

  const closeDialogRefuse = () => {
    setShowDialogRefusePayment(false);
    setCashierReceivedMoney("");
  };
  const fetchOpinion = async () => {
    const fetch = await APIService.depositOpinionDetail({
      depositId: transferId,
    });
    const opinion = fetch?.data?.data?.opinion;
    setOpinion(opinion);
    /*if(!opinion){
      setShowFeedBack(true)
    }*/
  };

  const closeWindowUpload = () => {
    window.setTimeout(() => {
      fetchPics(depositDetail?.id || "");
    }, 3000);
    if (status === "completed") {
      setCashierReceivedMoney("");
    }
    setStatus(status === "refused" ? "refused" : "completed");
  };

  useEffect(() => {
    setCashierReceivedMoney("");
  }, [transferId]);

  useEffect(() => {
    if (status === "completed") {
      fetchOpinion();
    }
  }, [status]);
  useEffect(() => {
    if ((processors?.length || 0) === 0) {
      fetchProccesors();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [processors]);
  useEffect(() => {
    setAnwersConfirmRefused(false);
  }, [showDialogRefusePayment]);

  return (
    <Fragment>
      <div
        className="h-48 md:h-64 w-full bg-cover bg-center relative"
        style={{ backgroundImage: `url(${getDollarOneImg()})` }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 to-black/40"></div>
      </div>
      <div className="relative -top-32 md:-top-40">
        {!loading ? (
          <>
            <section className="bg-white rounded-2xl px-4 md:px-8 lg:px-12 border border-gray-200 shadow-2xl py-6 w-full md:w-11/12 mx-auto">
              {/* Header Section */}
              <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 pb-6 mb-6 border-b border-gray-200">
                <div className="flex items-center gap-4">
                  <button
                    onClick={() => navigate(-1)}
                    className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
                  >
                    <BsFillArrowLeftSquareFill
                      size={28}
                      className="text-dark-green"
                    />
                  </button>
                  <div>
                    <h1 className="text-2xl md:text-3xl font-bold text-gray-800">
                      {t("depositdetail.detail")} <span className="text-dark-green">{depositDetail?.code}</span>
                    </h1>
                    <p className="text-sm text-gray-500 mt-1">Detalle completo de la transferencia</p>
                  </div>
                </div>
                <div className="flex items-center gap-4 bg-gray-50 rounded-xl px-4 py-3 border border-gray-200">
                  <div className="flex items-center gap-2 text-gray-600">
                    <HiCalendar size={18} />
                    <span className="text-sm font-medium">{dateToLocal(depositDetail?.createdAt)}</span>
                  </div>
                  <div className="h-6 w-px bg-gray-300"></div>
                  <div className="flex items-center gap-2 text-gray-600">
                    <HiClock size={18} />
                    <span className="text-sm font-medium">{dateToLocalHour(depositDetail?.createdAt)}</span>
                  </div>
                </div>
              </div>
              {/* Profits Section */}
              {depositDetail && (
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
                  <div className="bg-gradient-to-br from-emerald-50 to-emerald-100 rounded-xl p-5 border-2 border-emerald-200 shadow-md">
                    <div className="flex items-center gap-3 mb-3">
                      <div className="w-12 h-12 bg-emerald-500 rounded-xl flex items-center justify-center">
                        <HiCurrencyDollar className="text-white" size={24} />
                      </div>
                      <div>
                        <div className="text-sm font-semibold text-emerald-700 uppercase tracking-wide">
                          {transferId === user?.id ? "Has ganado" : "Ganancia del cajero"}
                          </div>
                        {user?.role === "admin" && (
                          <div className="text-xs text-emerald-600 mt-1">
                            {depositDetail?.percentcashier}% aplicado
                          </div>
                        )}
                        </div>
                            </div>
                    <div className="text-3xl font-bold text-emerald-800">
                      ${depositDetail?.profitcashier} <span className="text-lg text-emerald-600">USD</span>
                          </div>
                      </div>

                  <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-5 border-2 border-blue-200 shadow-md">
                    <div className="flex items-center gap-3 mb-3">
                      <div className="w-12 h-12 bg-blue-500 rounded-xl flex items-center justify-center">
                        <HiCurrencyDollar className="text-white" size={24} />
                      </div>
                        <div>
                        <div className="text-sm font-semibold text-blue-700 uppercase tracking-wide">
                          Swap de transferencia
                        </div>
                        {user?.role === "admin" && (
                          <div className="text-xs text-blue-600 mt-1">
                            {depositDetail?.percenthouse}% de la casa
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="text-3xl font-bold text-blue-800">
                      ${depositDetail?.profithouse} <span className="text-lg text-blue-600">USD</span>
                  </div>
                    </div>

                  <div className="bg-gradient-to-br from-amber-50 to-amber-100 rounded-xl p-5 border-2 border-amber-200 shadow-md">
                    <div className="flex items-center gap-3 mb-3">
                      <HiInformationCircle className="text-amber-600" size={24} />
                      <div className="text-sm font-semibold text-amber-700 uppercase tracking-wide">
                        Tipo de cambio
                  </div>
                </div>
                    <div className="text-lg font-bold text-amber-800">
                      {depositDetail?.currentusd} <span className="text-sm text-amber-600">USD/Fiat</span>
              </div>
                    <div className="text-xs text-amber-600 mt-2">
                      Valor utilizado para los cálculos
                      </div>
                  </div>
                </div>
              )}

              {/* User Section */}
              <div className="mb-6">
                <h2 className="text-lg font-bold text-gray-800 mb-4 flex items-center gap-2">
                  <HiUser size={20} className="text-dark-green" />
                  Usuario responsable de la transferencia
                </h2>
                <div className="bg-white rounded-xl border border-gray-200 shadow-md p-6">
                  <div className="flex flex-col md:flex-row items-start md:items-center gap-6">
                    <div className="flex items-center gap-4 flex-1">
                      <div
                        className="w-20 h-20 bg-cover bg-center rounded-2xl cursor-pointer hover:ring-4 hover:ring-dark-green/20 transition-all shadow-lg"
                        onClick={() =>
                          navigate(`/usuario/${depositDetail?.user?.id}`)
                        }
                        style={{
                          backgroundImage: `url(${
                            (depositDetail?.user?.photoUrl?.length || 0) > 0
                              ? process.env.REACT_APP_PROFILEPICTURE +
                                (depositDetail?.user?.photoUrl || "")
                              : getProfileDefaultImage()
                          })`,
                        }}
                      ></div>
                      <div className="flex-1">
                        <div
                          onClick={() =>
                            navigate(`/usuario/${depositDetail?.user.id}`)
                          }
                          className="text-xl font-bold text-gray-800 cursor-pointer hover:text-dark-green transition-colors mb-1"
                        >
                          {depositDetail?.user.fullname}
                        </div>
                        <div className="flex items-center gap-2 text-sm text-gray-600">
                          <span className="font-medium">Última conexión:</span>
                          <span className="bg-gray-100 px-2 py-1 rounded-md text-xs font-semibold">
                            {FormatLastConnection({
                              lastConnection:
                                depositDetail?.user?.lastConnection,
                            })}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="flex items-center gap-3">
                    {transferId && depositDetail && (
                      <OpenChatTransfer
                        destinyPhotoUrl={depositDetail?.user?.photoUrl || ""}
                        destinyFullname={depositDetail?.user?.fullname || ""}
                        destinyLastConnection={
                          depositDetail?.user?.lastConnection || ""
                        }
                        status={depositDetail?.status || ""}
                        depositId={transferId}
                      />
                    )}
                  {depositDetail?.status === "waitpay" && (
                        <div className="flex items-center gap-2 px-4 py-2 bg-red-50 border-2 border-red-200 rounded-lg">
                          <BsFillClockFill size={20} className="text-red-600" />
                          <div className="text-sm font-semibold text-red-700">
                        {t("deposits.thiswillcancel")}{" "}
                        {getHourDateExpirate(
                          dateToLocalComplete(
                            depositDetail?.createdAt
                          ).toString(),
                          parseInt(depositDetail?.timeinhour)
                        )}
                      </div>
                        </div>
                  )}
                    </div>
                  </div>
                </div>
              </div>

              {/* Weltrade Notice */}
              {(depositDetail?.systemProcessor?.name
                ?.toLowerCase()
                .includes("weltrade") ||
                depositDetail?.destinyProcessor?.name
                  ?.toLowerCase()
                  .includes("weltrade")) && (
                <div className="mb-6 p-4 bg-gradient-to-r from-amber-100 to-amber-50 border-2 border-amber-300 rounded-xl shadow-md">
                  <div className="flex items-center justify-center gap-2 text-amber-800 font-bold text-base">
                    <HiInformationCircle size={20} />
                  Esta transferencia representa un{" "}
                  {depositDetail?.systemProcessor?.name
                    ?.toLowerCase()
                    .includes("weltrade")
                    ? "retiro weltrade"
                    : "deposito weltrade"}
                  </div>
                </div>
              )}

              {/* Transfer Details */}
              {depositDetail && (
                <div className="mb-6">
                  <h2 className="text-lg font-bold text-gray-800 mb-4 flex items-center gap-2">
                    <RiMoneyDollarCircleFill size={20} className="text-dark-green" />
                    Detalles de la Transferencia
                  </h2>
                  <div className="bg-gradient-to-br from-white to-gray-50 rounded-2xl border-2 border-gray-200 shadow-xl p-5 relative">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                      {/* From Section */}
                      <div className="bg-white rounded-xl p-5 border border-gray-200 shadow-md">
                        <div className="flex items-center gap-4 mb-3">
                          <div className="w-14 h-14 bg-gradient-to-br from-emerald-500 to-emerald-600 rounded-xl flex items-center justify-center shadow-lg">
                            <RiMoneyDollarCircleFill className="text-white" size={28} />
                        </div>
                        <div>
                            <div className="text-sm font-semibold text-gray-500 uppercase tracking-wide">Recibirá</div>
                            <div className="text-2xl font-bold text-gray-800">
                              ${money(depositDetail?.money)}{" "}
                              <span className="text-lg text-gray-600">
                            {getFiatName(
                              depositDetail?.systemProcessor.id,
                              processors
                            )}
                              </span>
                          </div>
                          </div>
                        </div>
                        <div className="mt-3 pt-3 border-t border-gray-200">
                          <div className="text-sm font-medium text-gray-600 mb-3">{t("paymethod")}</div>
                          <div className="flex items-center gap-4">
                            <img
                              alt="procesador"
                              className="w-28 h-28 object-contain bg-gray-50 rounded-xl p-3 shadow-sm"
                              src={`${process.env.REACT_APP_PROCESSOR_IMAGE}${depositDetail?.systemProcessor?.photoUrl}`}
                            />
                            <div className="font-semibold text-gray-800 text-lg">
                              {depositDetail?.systemProcessor?.name ||
                                t("nodata")}
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Arrow */}
                      <div className="hidden lg:flex items-center justify-center absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10">
                        <div className="bg-white rounded-full p-3 shadow-lg border-2 border-gray-200">
                          <HiArrowRight className="text-dark-green" size={32} />
                        </div>
                      </div>

                      {/* To Section */}
                      <div className="bg-white rounded-xl p-5 border border-gray-200 shadow-md">
                        <div className="flex items-center gap-4 mb-3">
                          <div className="w-14 h-14 bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl flex items-center justify-center shadow-lg">
                            <HiCurrencyDollar className="text-white" size={28} />
                          </div>
                          <div>
                            <div className="text-sm font-semibold text-gray-500 uppercase tracking-wide">{t("totalpay")}</div>
                            <div className="text-2xl font-bold text-gray-800">
                              ${money(depositDetail?.totaltopay)}{" "}
                              <span className="text-lg text-gray-600">
                          {getFiatName(
                            depositDetail?.destinyProcessor.id,
                            processors
                          )}
                              </span>
                        </div>
                          </div>
                        </div>
                        <div className="mt-3 space-y-3">
                          <div>
                            <div className="text-sm font-medium text-gray-600 mb-3">{t("paymethod")}</div>
                            <div className="flex items-center gap-4">
                          <img
                            alt="procesador"
                                className="w-28 h-28 object-contain bg-gray-50 rounded-xl p-3 shadow-sm"
                            src={`${process.env.REACT_APP_PROCESSOR_IMAGE}${depositDetail?.destinyProcessor?.photoUrl}`}
                          />
                              <div className="font-semibold text-gray-800 text-lg">
                                {depositDetail?.destinyProcessor?.name}
                        </div>
                        </div>
                        </div>
                          <div className="pt-3 border-t border-gray-200 space-y-2">
                            <div className="text-sm font-medium text-gray-600">Información de la cuenta</div>
                            <div className="bg-gray-50 rounded-lg p-3 space-y-1 text-sm">
                              <div className="font-semibold text-gray-800">
                                {(methodPayment?.number?.length || 0) > 0 && (
                                  <div>Número: {methodPayment?.number}</div>
                            )}
                          </div>
                              {(methodPayment?.typered?.length || 0) > 0 && (
                                <div className="text-gray-700">Red: {methodPayment?.typered}</div>
                              )}
                              {methodPayment?.accounttype && (
                                <div className="text-gray-700">
                                  {t(`bankaccounttype.${methodPayment?.accounttype}`)}
                        </div>
                              )}
                              {(methodPayment?.nametitular?.length || 0) > 0 && (
                                <div className="font-semibold text-gray-800 pt-2 border-t border-gray-200">
                                  Titular: {methodPayment?.nametitular}
                                  {methodPayment?.identificationtype && ` (${methodPayment?.identificationtype})`}
                                  {methodPayment?.identification && ` - ${methodPayment?.identification}`}
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="pt-3 border-t border-gray-200">
                            <div className="text-sm font-medium text-gray-600 mb-2">{t("status")}</div>
                          {status &&
                            (user?.role === "admin" ? (
                              <DepositStatus
                                userId={depositDetail?.user.id}
                                depositId={depositDetail?.id}
                                depositCode={depositDetail?.code}
                                currentStatus={status || ""}
                                moneyFrom={`${money(
                                  depositDetail?.money
                                )} ${getFiatName(
                                  depositDetail?.systemProcessor.id,
                                  processors
                                )}`}
                                moneyTo={`${money(
                                  depositDetail?.totaltopay
                                )}${getFiatName(
                                  depositDetail?.destinyProcessor.id,
                                  processors
                                )}`}
                              />
                            ) : (
                              <ViewDepositStatus currentStatus={status} />
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {depositDetail?.depositAppeal && (
                <AppealResume
                  commentByAdmin={depositDetail?.depositAppeal?.commentByAdmin}
                  commentByUser={depositDetail?.depositAppeal?.commentByUser}
                />
              )}

              {/* Rating Section */}
              {opinion?.calification && (
                <div className="mb-6">
                  <h2 className="text-lg font-bold text-gray-800 mb-4 flex items-center gap-2">
                    <IoStar size={20} className="text-amber-500" />
                    Calificación del Servicio
                  </h2>
                  <div className="bg-gradient-to-br from-amber-50 to-amber-100 rounded-xl border-2 border-amber-200 shadow-md p-6">
                    <div className="grid md:grid-cols-2 gap-6">
                      <div className="flex flex-col items-center justify-center">
                        <div className="text-5xl font-bold text-amber-700 mb-2">
                      {Number(opinion?.calification || 0).toFixed(1)}
                        </div>
                        <div className="flex items-center justify-center gap-1">
                        {Array.from(
                            new Array(Math.floor(opinion?.calification || 0)).keys()
                        ).map((c) => (
                          <IoStar
                            key={c}
                              size={32}
                              className="text-amber-400 fill-amber-400"
                          />
                        ))}
                      </div>
                    </div>
                    {(opinion?.comment?.length || 0) > 0 && (
                        <div className="bg-white rounded-lg p-4 border border-amber-200 shadow-sm">
                          <div className="text-xs font-semibold text-amber-700 uppercase tracking-wide mb-2">
                            Comentario del cliente
                        </div>
                          <div className="text-gray-700 italic">"{opinion?.comment}"</div>
                      </div>
                    )}
                    </div>
                  </div>
                </div>
              )}

              {/* Payment Receipts Section */}
              <div className="mb-6">
                <h2 className="text-lg font-bold text-gray-800 mb-4 flex items-center gap-2">
                  <HiCheckCircle size={20} className="text-dark-green" />
                  Comprobantes de Pago
                </h2>
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-20">
                {/* Cashier Receipts */}
                <div className="bg-white rounded-xl border-2 border-gray-200 shadow-lg overflow-hidden">
                  <div className="bg-gradient-to-r from-emerald-500 to-emerald-600 px-6 py-4">
                    <h3 className="text-lg font-bold text-white text-center">
                      {user?.role === "cashier" && "Mis Comprobantes (Cajero)"}
                      {user?.role === "admin" && "Archivos Enviados por el Cajero"}
                    </h3>
              </div>
                  <div className="p-6">
                    {status === "completed" && (
                      <div className="mb-4 p-3 bg-emerald-50 border border-emerald-200 rounded-lg text-center">
                        <div className="flex items-center justify-center gap-2 text-emerald-700 font-semibold">
                          <HiCheckCircle size={20} />
                          La transacción ha finalizado
                      </div>
                      </div>
                    )}
                    {status === "refused" && (
                      <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg text-center">
                        <div className="flex items-center justify-center gap-2 text-red-700 font-semibold">
                          <HiXCircle size={20} />
                          La transacción ha sido rechazada
                        </div>
                      </div>
                    )}
                    {status === "appeal" && (
                      <div className="mb-4 p-3 bg-amber-50 border border-amber-200 rounded-lg text-center">
                        <div className="flex items-center justify-center gap-2 text-amber-700 font-semibold">
                          <HiInformationCircle size={20} />
                          La transacción se encuentra en revisión
                        </div>
                      </div>
                    )}

                      {status === "checking" && cashierReceivedMoney === "" && (
                      <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-6 border-2 border-blue-200 mb-4">
                        <div className="text-center mb-4">
                          <div className="text-lg font-bold text-gray-800 mb-2">
                              ¿Recibiste el pago del cliente?
                            </div>
                          <div className="text-sm text-gray-600">
                            Confirma si recibiste el pago completo
                          </div>
                        </div>
                        <div className="flex flex-col sm:flex-row gap-3 justify-center">
                          <button
                                onClick={() => setCashierReceivedMoney("true")}
                            className="flex-1 flex items-center justify-center gap-2 bg-gradient-to-r from-emerald-500 to-emerald-600 hover:from-emerald-600 hover:to-emerald-700 text-white px-6 py-3 rounded-xl font-bold shadow-md hover:shadow-lg transition-all transform hover:scale-105"
                          >
                            <AiOutlineLike size={22} />
                            Sí, Confirmado
                          </button>
                          <button
                            onClick={() => {
                              openMotiveWindow();
                              setCashierReceivedMoney("false");
                            }}
                            className="flex-1 flex items-center justify-center gap-2 bg-gradient-to-r from-gray-800 to-gray-900 hover:from-gray-900 hover:to-black text-white px-6 py-3 rounded-xl font-bold shadow-md hover:shadow-lg transition-all transform hover:scale-105"
                          >
                            <AiOutlineDislike size={22} />
                            No, Rechazar
                          </button>
                              </div>
                            </div>
                      )}

                      {(pics?.filter((p) => p.responsable === "cashier")
                        ?.length || 0) === 0 &&
                        status === "checking" &&
                      cashierReceivedMoney !== "" && (
                          <div className="w-full">
                            {status === "checking" &&
                              !loading &&
                              !loadingUploadPics && (
                              <div className="flex justify-end mb-3">
                                <Tooltip placement="top" title="Regresar">
                                  <button
                                    onClick={() => setCashierReceivedMoney("")}
                                    className="p-2 hover:bg-red-50 rounded-lg transition-colors"
                                  >
                                    <IoCloseCircleSharp
                                      size={24}
                                      className="text-red-500"
                                    />
                                  </button>
                                </Tooltip>
                              </div>
                              )}
                            <div className="w-full text-left font-medium text-sm py-4">
                              <UploadManyFiles
                                success={() => closeWindowUpload()}
                                type="cashierpayment"
                                currentStatus={status || ""}
                                transferId={depositDetail?.id || ""}
                                newStatus={"completed"}
                                setLoadingUpload={setLoadingUploadPics}
                              />
                            </div>
                          </div>
                        )}
                        <GalleryPics
                          title={`Transferencia ${
                            depositDetail?.code
                          } por el valor de ${money(
                            depositDetail?.totaltopay || 0
                          )}`}
                          description={`Comprobante de pago enviado por el cajero ${depositDetail?.cashier?.fullname}`}
                          photoUrl={pics?.filter(
                            (p) => p.responsable === "cashier"
                          )}
                          code={depositDetail?.code}
                        />
                  </div>
                </div>

                {/* Client Receipts */}
                <div className="bg-white rounded-xl border-2 border-gray-200 shadow-lg overflow-hidden">
                  <div className="bg-gradient-to-r from-blue-500 to-blue-600 px-6 py-4">
                    <h3 className="text-lg font-bold text-white text-center">
                      Comprobantes de Pago (Cliente)
                    </h3>
                  </div>
                  <div className="p-6">
                  {(status === "cancel" || status === "refused") && (
                      <div className="mb-4 space-y-3">
                        <div className="flex items-center justify-center gap-2 text-base font-semibold py-3 bg-red-50 border border-red-200 rounded-lg">
                          <FcCancel size={23} />
                          Estado: {t(`depositstatus.${status}`)}
                        </div>
                        <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
                          <div className="text-sm font-semibold text-gray-700 mb-2">
                          {t("motiveseted")}
                          </div>
                          <div className="text-gray-800 font-medium">
                            {depositDetail?.motive}
                          </div>
                        </div>
                      </div>
                  )}
                  {status === "waitpay" && (
                      <div className="text-center py-8">
                        <div className="text-lg font-semibold text-gray-600 mb-2">
                          {t("withoutpay")}
                        </div>
                        <div className="text-sm text-gray-500">
                          El cliente aún no ha enviado el comprobante de pago
                        </div>
                    </div>
                  )}
                  {status !== "waitpay" && (
                    <div>
                        <div className="text-center mb-4">
                          <div className="inline-flex items-center gap-2 px-4 py-2 bg-blue-50 border border-blue-200 rounded-lg">
                            <HiCheckCircle className="text-blue-600" size={20} />
                            <span className="font-semibold text-blue-700">{t("paysent")}</span>
                      </div>
                        </div>
                            <GalleryPics
                              title={`Transferencia ${
                                depositDetail?.code
                              } por el valor de ${money(
                                depositDetail?.money || 0
                              )}`}
                              description={`Comprobante de pago enviado por ${depositDetail?.user?.fullname}`}
                              photoUrl={pics.filter(
                                (p) =>
                                  p.responsable === "user" &&
                                  (user?.role === "cashier"
                                    ? p.type !== "evidence"
                                    : true)
                              )}
                              code={depositDetail?.code}
                            />
                          </div>
                    )}
                        </div>
                      </div>
                </div>
              </div>
            </section>

            <DialogConfirm
              show={showDialogRefusePayment}
              disabledFooter={true}
              size="xl:w-4/5"
              disabledClosable={true}
              closeDialog={() => closeDialogRefuse()}
            >
              <div className="relative overflow-hidden">
                {/* Background gradient */}
                <div className="absolute top-0 left-0 right-0 h-32 bg-gradient-to-br from-red-500 via-red-600 to-red-500 opacity-10"></div>
                
                <div className="relative">
                  {(successCancel === "yes" || successCancel === "no") ? (
                    <div className="p-8">
                      {successCancel === "yes" && (
                        <div className="text-center py-8">
                          <div className="w-20 h-20 bg-gradient-to-br from-emerald-100 to-emerald-200 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
                            <HiCheckCircle className="text-emerald-600" size={48} />
                          </div>
                          <h3 className="text-2xl font-bold text-gray-800 mb-2">
                            Transferencia Rechazada
                          </h3>
                          <p className="text-gray-600 mb-6">
                            La transferencia ha sido rechazada exitosamente. El cliente ha sido notificado.
                          </p>
                          <button
                            onClick={() => handleSuccessCancel()}
                            className="px-8 py-3 bg-gradient-to-r from-emerald-500 to-emerald-600 hover:from-emerald-600 hover:to-emerald-700 text-white rounded-xl font-bold shadow-md hover:shadow-lg transition-all duration-200 transform hover:scale-105"
                          >
                            Aceptar
                          </button>
                        </div>
                      )}

                      {successCancel === "no" && (
                        <div className="text-center py-8">
                          <div className="w-20 h-20 bg-gradient-to-br from-red-100 to-red-200 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
                            <HiXCircle className="text-red-600" size={48} />
                          </div>
                          <h3 className="text-2xl font-bold text-gray-800 mb-2">
                            Error al Rechazar
                          </h3>
                          <p className="text-gray-600 mb-6">
                            No fue posible rechazar la transferencia. Por favor, intente nuevamente.
                          </p>
                          <button
                            onClick={() => handleSuccessCancel()}
                            className="px-8 py-3 bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white rounded-xl font-bold shadow-md hover:shadow-lg transition-all duration-200 transform hover:scale-105"
                          >
                            Aceptar
                          </button>
                        </div>
                      )}
                    </div>
                  ) : (
                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-0">
                      {/* Main Content */}
                      <div className="lg:col-span-2 p-6 lg:p-8">
                        {/* Header */}
                        <div className="mb-6">
                          <div className="flex items-center gap-4 mb-4">
                            <div className="w-16 h-16 bg-gradient-to-br from-red-500 to-red-600 rounded-2xl flex items-center justify-center shadow-lg">
                              <HiExclamationTriangle className="text-white" size={32} />
                            </div>
                            <div>
                              <h2 className="text-2xl font-bold text-gray-800 mb-1">
                                Rechazar Transferencia
                              </h2>
                              <p className="text-sm text-gray-500">
                                Confirma los detalles antes de proceder
                              </p>
                            </div>
                          </div>

                          {!anwersConfirmRefused && (
                            <div className="bg-red-50 border-2 border-red-200 rounded-xl p-5 mb-6">
                              <div className="flex items-start gap-3">
                                <HiShieldExclamation className="text-red-600 flex-shrink-0 mt-0.5" size={24} />
                                <div>
                                  <div className="font-bold text-red-800 mb-2">
                                    ¿Confirmas que no has recibido el pago completo?
                                  </div>
                                  <div className="text-lg font-bold text-red-700">
                                    ${money(depositDetail?.money)}{" "}
                            {getFiatName(
                              depositDetail?.systemProcessor.id,
                              processors
                                    )}
                                  </div>
                                </div>
                              </div>
                          </div>
                        )}

                          {anwersConfirmRefused && (
                            <div className="bg-blue-50 border-2 border-blue-200 rounded-xl p-5 mb-6">
                              <div className="flex items-start gap-3">
                                <HiInformationCircle className="text-blue-600 flex-shrink-0 mt-0.5" size={24} />
                                <div className="text-blue-800 font-medium">
                                  El cliente será notificado de la cancelación de su transferencia.
                  </div>
                      </div>
                      </div>
                          )}
                        </div>

                        {/* Reason Selection */}
                        <div>
                          <div className="mb-6">
                            <label className="block text-base font-bold text-gray-800 mb-3">
                              Motivo del rechazo
                            </label>
                            <p className="text-sm text-gray-600 mb-4">
                              Selecciona una respuesta predeterminada o escribe tu propio motivo
                            </p>
                            
                            {/* Predefined Answers */}
                            <div className="grid grid-cols-1 gap-2 mb-4">
                      {answers.map((a, k) => (
                                <button
                          key={k.toString()}
                                  onClick={() => setCommentCancel(a)}
                                  className={`text-left p-4 rounded-xl border-2 transition-all duration-200 ${
                                    commentCancel === a
                                      ? 'bg-emerald-50 border-emerald-400 shadow-md'
                                      : 'bg-gray-50 border-gray-200 hover:border-emerald-300 hover:bg-emerald-50'
                                  }`}
                                >
                                  <div className="flex items-center gap-3">
                                    <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${
                                      commentCancel === a
                                        ? 'border-emerald-500 bg-emerald-500'
                                        : 'border-gray-300'
                                    }`}>
                                      {commentCancel === a && (
                                        <div className="w-2 h-2 bg-white rounded-full"></div>
                                      )}
                        </div>
                                    <span className="text-sm font-medium text-gray-700">{a}</span>
                                  </div>
                                </button>
                              ))}
                            </div>

                            {/* Custom Textarea */}
                            <div className="mt-6">
                              <label className="block text-sm font-semibold text-gray-700 mb-2">
                                O escribe tu propio motivo
                              </label>
                        <textarea
                                placeholder="Describe el motivo del rechazo de manera clara y profesional..."
                          maxLength={200}
                          value={commentCancel}
                          onChange={(e) => handleCommentCancel(e.target.value)}
                                className="w-full h-32 p-4 border-2 border-gray-300 rounded-xl focus:border-emerald-500 focus:ring-2 focus:ring-emerald-200 transition-all resize-none text-base font-medium placeholder-gray-400"
                        ></textarea>
                              <div className="flex justify-between items-center mt-2">
                                <div className="text-xs text-gray-500">
                                  Este mensaje será enviado al cliente
                        </div>
                                <div className={`text-sm font-semibold ${
                                  (commentCancel?.length || 0) > 180 ? 'text-red-600' : 'text-gray-400'
                                }`}>
                                  {commentCancel?.length || 0}/200
                      </div>
                    </div>
                            </div>
                          </div>

                          {/* Action Buttons */}
                          <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 pt-4 border-t border-gray-200">
                            {!loadingCancel && (
                              <button
                                onClick={() => closeDialogRefuse()}
                                className="flex-1 sm:flex-initial px-6 py-3 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-xl font-semibold transition-all duration-200"
                              >
                                Cancelar
                              </button>
                            )}
                      {(commentCancel?.length || 0) > 2 && (
                        <button
                          onClick={() =>
                            !loadingCancel ? handleRefuseTransfer() : null
                          }
                                disabled={loadingCancel}
                                className="flex-1 sm:flex-initial flex items-center justify-center gap-2 px-6 py-3 bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white rounded-xl font-bold shadow-lg hover:shadow-xl transition-all duration-200 transform hover:scale-105 disabled:opacity-70 disabled:cursor-not-allowed disabled:transform-none"
                        >
                          {!loadingCancel ? (
                                  <>
                                    <HiXCircle size={20} />
                                    Rechazar Transferencia
                                  </>
                          ) : (
                                  <>
                                    <ImSpinner9 className="animate-spin" size={20} />
                                    Procesando...
                                  </>
                          )}
                        </button>
                      )}
                    </div>
                        </div>
                      </div>

                      {/* Sidebar Info */}
                      {successCancel === "" && (
                        <div className="lg:col-span-1 bg-gradient-to-br from-gray-50 to-gray-100 p-6 lg:p-8 border-t-2 lg:border-t-0 lg:border-l-2 border-gray-200">
                          <div className="sticky top-6">
                            <div className="flex items-center gap-3 mb-6">
                              <div className="w-12 h-12 bg-blue-500 rounded-xl flex items-center justify-center">
                                <HiInformationCircle className="text-white" size={24} />
                      </div>
                              <h3 className="text-lg font-bold text-gray-800">
                                Información Importante
                              </h3>
                    </div>

                            <div className="space-y-4">
                              <div className="bg-white rounded-xl p-4 border border-gray-200 shadow-sm">
                                <div className="text-sm font-semibold text-gray-800 mb-2">
                                  ⚠️ Consecuencias
                      </div>
                                <div className="text-sm text-gray-600 leading-relaxed">
                                  Si confirmas que no has recibido el pago, la transferencia será rechazada y se notificará automáticamente al cliente.
                    </div>
                </div>

                              <div className="bg-white rounded-xl p-4 border border-gray-200 shadow-sm">
                                <div className="text-sm font-semibold text-gray-800 mb-3">
                                  📋 Pasos del Proceso
                  </div>
                                <div className="space-y-2 text-sm text-gray-600">
                                  <div className="flex items-start gap-2">
                                    <span className="font-bold text-blue-600">1.</span>
                                    <span>Escribe un motivo claro y profesional por el cual rechazas la transferencia.</span>
                  </div>
                                  <div className="flex items-start gap-2">
                                    <span className="font-bold text-blue-600">2.</span>
                                    <span>Presiona el botón 'Rechazar Transferencia' para finalizar el proceso.</span>
                  </div>
                  </div>
                  </div>

                              <div className="bg-blue-50 border-2 border-blue-200 rounded-xl p-4">
                                <div className="text-xs font-semibold text-blue-800 uppercase tracking-wide mb-2">
                                  💡 Recomendación
                                </div>
                                <div className="text-sm text-blue-700">
                                  Sé específico y claro en el motivo del rechazo para ayudar al cliente a entender la situación.
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </DialogConfirm>
          </>
        ) : (
          <section className="w-11/12 mx-auto">
            <SkeletonDepositDetail />
          </section>
        )}
      </div>
    </Fragment>
  );
};
export default DepositDetail;
